// extracted by mini-css-extract-plugin
module.exports = {"boxWrapper":"TicketTypeModal__boxWrapper___jyUld"};